import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { Record } from 'immutable';
import { CommonParamActions } from '../actions/commonParam';
import { ConnectedCompanies, CustomerDestinations } from '../models/CommonParam';

export class CommonParamState extends Record<{
    mandt: string;
    customerDestinations: CustomerDestinations;
    connectedCompanies: ConnectedCompanies;
}>({
    mandt: "",
    customerDestinations: new CustomerDestinations(),
    connectedCompanies: new ConnectedCompanies(),
}) {

}

export const CommonParamReducer = reducerWithInitialState(new CommonParamState())
    .case(CommonParamActions.setMandt, (state, payload) => {
        return state.set('mandt', payload);
    })
    .case(CommonParamActions.setCustomerDestinations, (state, payload) => {
        return state.set('customerDestinations', payload);
    })
    .case(CommonParamActions.setConnectedCompanies, (state, payload) => {
        return state.set('connectedCompanies', payload);
    })
    ;